import loadCategoryImages from './loadCategoriesImages';

const localImages = loadCategoryImages();

const normalizeSlug = (slug = '') =>
  slug.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

/**
 * Imagen de una categoría: la subida desde el admin (`image_url`) o, si no hay,
 * la ilustración incluida en el sitio (assets/icons/<slug>.svg). null si no tiene ninguna.
 * La usan la página de categorías, las etiquetas y el admin, para mostrar siempre la misma.
 */
const categoryImageSrc = (category) => {
  if (category?.image_url) return category.image_url;
  const local = localImages[`${normalizeSlug(category?.slug || category?.name)}.svg`];
  return local ? (local.default || local) : null;
};

export default categoryImageSrc;
